// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3UuaD","visuallyhidden":"_3LxyF","hide-text":"_1G9vd","center":"_1u91Q","noprint":"_3pelG","headline":"_1o64I"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-headline/styles/default.scss
 ** module id = 1004
 ** module chunks = 2
 **/